import { SensitiveSkinFrequencyRank } from "./v1";

export type SensitiveSkinFrequencyRankV1Type = keyof typeof SensitiveSkinFrequencyRank;

export type SensitiveSkinFrequencyRankType = SensitiveSkinFrequencyRankV1Type;
